<template>
    <div>
        <div class="text-center">
            <img src="/img/logo.png" class="standalone-logo" />
        </div>
        <form @submit.prevent="login" class="mt-4" v-if="step === 'credentials'">
            <b-input-group class="mb-4">
                <b-input-group-prepend>
                    <b-input-group-text>
                        <i class="icon-user"></i>
                    </b-input-group-text>
                </b-input-group-prepend>
                <input name="username" v-validate="'required'" data-vv-as="Tên đăng nhập" class="form-control"
                    placeholder="Tên đăng nhập" v-model="username" />
                <div v-show="errors.has('username')" class="validation-message text-danger">
                    {{ errors.first('username') }}
                </div>
            </b-input-group>
            <b-input-group class="mb-4">
                <b-input-group-prepend>
                    <b-input-group-text>
                        <i class="icon-lock"></i>
                    </b-input-group-text>
                </b-input-group-prepend>
                <input type="password" class="form-control" :placeholder="$t('loginPage.password')" v-model="password"
                    name="password" v-validate="'required'" :data-vv-as="$t('loginPage.password')" />
                <div v-show="errors.has('password')" class="validation-message text-danger">
                    {{ errors.first('password') }}
                </div>
            </b-input-group>
            <b-button block type="submit" variant="primary" class="px-4 mt-2">{{
                $t('loginPage.login')
            }}</b-button>
        </form>
        <form @submit.prevent="login" class="mt-4" v-else>
            <p class="text-muted mb-4">{{ $t('loginPage.codeSent', { email: twoFactorEmail }) }}</p>
            <b-input-group class="mb-4">
                <b-input-group-prepend>
                    <b-input-group-text>
                        <i class="fa fa-key"></i>
                    </b-input-group-text>
                </b-input-group-prepend>
                <input name="code" v-validate="'required'" :data-vv-as="$t('loginPage.code')" class="form-control"
                    :placeholder="$t('loginPage.code')" v-model.trim="code" maxlength="6"
                    autocomplete="one-time-code" />
                <div v-show="errors.has('code')" class="validation-message text-danger">
                    {{ errors.first('code') }}
                </div>
            </b-input-group>
            <b-button block type="submit" variant="primary" class="px-4 mt-2">{{
                $t('loginPage.login')
            }}</b-button>
            <b-button block variant="outline-primary" class="px-4 mt-2" @click="resendCode">
                {{ $t('loginPage.resendCode') }}
            </b-button>
            <b-button block variant="link" class="px-4 mt-2" @click="reset">
                {{ $t('loginPage.back') }}
            </b-button>
        </form>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: 'Login',
    data() {
        return {
            username: null,
            password: null,
            code: null,
            step: 'credentials',
            twoFactorEmail: null
        };
    },
    methods: {
        ...mapActions({
            actionLogin: 'auth/actionLogin',
            getCurrentUserDetail: 'auth/getCurrentUserDetail',
            createAuditByUser: 'user/createAuditByUser'
        }),
        reset() {
            this.step = 'credentials';
            this.code = null;
            this.twoFactorEmail = null;
        },
        async login() {
            const result = await this.$validator.validateAll();
            if (!result) return;
            const { username, password, code } = this;
            const params = this.step === 'code' ? { username, password, code } : { username, password };
            const response = await this.actionLogin(params);
            if (response.twoFactor) {
                this.step = 'code';
                this.twoFactorEmail = response.email;
                this.code = null;
                this.$toaster.success(this.$t('loginPage.codeSent', { email: response.email }));
                return;
            }
            await this.getCurrentUserDetail();
            this.$emit('loginSuccess', true);
            this.createAuditByUser({ content: 'Đăng nhập hệ thống' });
            this.$toaster.success(this.$t('loginPage.loginSuccessMsg'));
            this.reset();
        },
        async resendCode() {
            const { username, password } = this;
            const response = await this.actionLogin({ username, password });
            if (response.twoFactor) {
                this.code = null;
                this.$toaster.success(this.$t('loginPage.codeSent', { email: response.email }));
            }
        }
    }
};
</script>
